export async function extractArrayMessageData(data) {
    if (typeof data === 'string') {
        throw new Error('Expected binary data, received string');
    }
    if (data instanceof ArrayBuffer) {
        return new Uint8Array(data);
    }
    if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
    }
    if (data instanceof Blob) {
        const buffer = await data.arrayBuffer();
        return new Uint8Array(buffer);
    }
    throw new Error('Unsupported WebSocket message data type');
}
//# sourceMappingURL=MessageUtils.js.map